"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const cronstrue_1 = __importDefault(require("cronstrue"));
const types_1 = require("../types");
const utils_1 = require("./utils");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
const NodeSummaryGenerator = {
  trigger: async data => {
    let triggers = [];
    if (data.schedule.active && data.schedule.value) {
      for (const schedule of data.schedule.value) {
        if (schedule.type === "rate") {
          let search = /\((.*?)\)/.exec(schedule.value);
          if (search) {
            triggers.push(`Runs every ${search[1]}`);
          }
        } else {
          let search = /\((.*?)\)/.exec(schedule.value);
          if (search) {
            triggers.push(
              `${cronstrue_1.default.toString(`0 ${search[1]}`, {
                dayOfWeekStartIndexZero: false
              })}`
            );
          }
        }
      }
    }
    if (data.alarm.active && data.alarm.value) {
      triggers.push(`Is triggered by an Alarm`);
    }
    if (data.http.active) {
      triggers.push(`Is triggered by External Application`);
    }
    if (triggers.length) {
      return triggers.join(", ");
    }
    return "Manual trigger";
  },
  resource: async (data, dataResolver) => {
    if (data.service && data.method) {
      let sgcData = await utils_1.getSgcData(
        dataResolver,
        `${cloudProvider_1.default.AWS}/resources.json`
      );
      let serviceObj = sgcData.find(u => u.service === data.service);
      if (!serviceObj) return null;
      let methodObj = serviceObj.resources.find(x => x.method === data.method);
      if (!methodObj) return null;
      return `${serviceObj.displayService} ${methodObj.displayName} `;
    }
    return null;
  },
  action: async (data, dataResolver) => {
    if (data.service && data.method) {
      let sgcData = await utils_1.getSgcData(
        dataResolver,
        `${cloudProvider_1.default.AWS}/actions.json`
      );
      let serviceObj = sgcData.find(u => u.service === data.service);
      if (!serviceObj) return null;
      let methodObj = serviceObj.actions.find(x => x.method === data.method);
      if (!methodObj) return null;
      return `${serviceObj.displayService} ${methodObj.displayName} `;
    }
    return null;
  },
  filter: async data => {
    if (Array.isArray(data.conditions)) {
      let filters = data.conditions.map(c => c.type);
      return `Filtering by ${filters.join(" & ")}`;
    }
    return null;
  },
  userapproval: async data => {
    let target =
      data.transport.type === types_1.NotificationType.SLACK
        ? data.transport.type
        : data.transport.options && data.transport.options.approvalEmail;
    if (target) {
      return `Sending a notification to ${target}`;
    }
    return null;
  },
  notification: async data => {
    let target =
      data.transport.type === types_1.NotificationType.SLACK
        ? data.transport.type
        : data.transport.options && data.transport.options.notifyEmail;
    if (target) {
      return `Sending a notification to ${target}`;
    }
    return null;
  },
  report: async data => {
    if (data.transport.type === types_1.NotificationType.NONE)
      return "Generating report";
    let target =
      data.transport.type === types_1.NotificationType.SLACK
        ? data.transport.options && data.transport.options.slackConfig
        : data.transport.options && data.transport.options.recipient;
    if (target) {
      return `Sending reports to ${target}`;
    }
    return null;
  },
  custom: async data => {
    if (data.code) {
      return `custom code is present`;
    } else {
      const values = Object.keys(data.variables).map(x => data.variables[x]);
      if (!values.includes(undefined) && !values.includes("")) {
        return `custom code ${data.link} is present`;
      }
    }
    return null;
  },
  monitoring: async data => {
    const Queries = data.Queries;
    if (Array.isArray(Queries)) {
      return Queries.map(q => `${q.Namespace}:${q.MetricName}`).join(", ");
    }
    return null;
  },
  delay: async data => {
    return `Wait for ${data.delay} seconds`;
  },
  http: async data => {
    let url = data.url;
    let parts = [];
    while (url.length) {
      parts.push(url.substr(0, 30));
      url = url.substr(30);
    }
    return parts.join(" ");
  },
  jenkins: async data => {
    return `Build ${data.job}`;
  },
  workflow: async data => {
    return `trigger next workflow ${data.targetWorkflow}`;
  },
  workflowReport: async data => {
    return "Sends workflow summary report";
  },
  throttling: async data => {
    return "Restrict execution";
  },
  adoption: async data => {
    return "adopt templates";
  },
  ssh: async data => {
    return "Execute ssh command";
  },
  network: async data => {
    return `Scanning ${data.cidr}`;
  },
  wolken: async data => {
    return `${data.action} cmdb items`;
  },
  vmware: async (data, dataResolver) => {
    if (!data.resource) return null;
    let sgcData = await utils_1.getSgcData(
      dataResolver,
      `${cloudProvider_1.default.VMWARE}/resources.json`
    );
    let serviceObj = sgcData.find(u => u.service === data.resource);
    if (!serviceObj) return null;
    return `VMware ${serviceObj.displayService}`;
  },
  "vmware-action": async (data, dataResolver) => {
    if (!data.action) return null;
    let sgcData = await utils_1.getSgcData(
      dataResolver,
      `${cloudProvider_1.default.VMWARE}/actions.json`
    );
    let serviceObj = sgcData.find(u => u.service === data.action);
    if (!serviceObj) return null;
    return `VMware Action ${serviceObj.displayName}`;
  },
  "azure-resource": async data => {
    return `${utils_1.wordify(data.module)} : ${utils_1.wordify(
      data.service
    )} : ${utils_1.wordify(data.method)}`;
  },
  "azure-action": async data => {
    return `${utils_1.wordify(data.module)} : ${utils_1.wordify(
      data.service
    )} : ${utils_1.wordify(data.method)}`;
  },
  "azure-monitoring": async data => {
    return `Use Metric ${data.metricnames}`;
  },
  "kubernetes-action": async function(data) {
    return `${utils_1.wordify(data.service)} : ${utils_1.wordify(data.method)}`;
  },
  "kubernetes-resource": async function(data) {
    return `${utils_1.wordify(data.service)} : ${utils_1.wordify(data.method)}`;
  },
  decision: async function(data) {
    return `Succeed when query has ${
      data.onPositiveLookupResult === "pass" ? "1 or more" : "zero"
    } result`;
  },
  parallel: async function(data) {
    return `Execute branches`;
  },
  "terraform-cloud-resource": async function(data) {
    return `${utils_1.wordify(data.service)} : ${utils_1.wordify(data.method)}`;
  },
  "terraform-cloud-action": async function(data) {
    return `${utils_1.wordify(data.service)} : ${utils_1.wordify(data.method)}`;
  },
  "user-defined-node": async function(data) {
    return "";
  },
  "data-formatter": async () => {
    return "Data formatter node";
  },
  "data-joiner": async data => {
    if (data.joinType) {
      return `${utils_1.wordify(data.joinType)} Join`;
    } else {
      return null;
    }
  },
  "gcp-resource": async data => {
    if (data) {
      return `Resource ${utils_1.wordify(data.module)} : ${utils_1.wordify(
        data.service
      )}: ${utils_1.wordify(data.method)}`;
    } else {
      return null;
    }
  },
  "gcp-action": async data => {
    if (data) {
      return `Action ${utils_1.wordify(data.module)} : ${utils_1.wordify(
        data.service
      )}: ${utils_1.wordify(data.method)}`;
    } else {
      return null;
    }
  }
};
async function getSummary(type, data, dataResolver) {
  if (!data) return null;
  return NodeSummaryGenerator[type](data, dataResolver);
}
exports.getSummary = getSummary;
//console.log(SERVICES);
//# sourceMappingURL=nodeSummary.js.map
